import React, { useEffect, useRef } from "react";

// SASS
import "./Part11.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import virusSticky1Img from "../../assets/img/virus-sticky-note-1.png";
import virusSticky2Img from "../../assets/img/virus-sticky-note-2.png";
import virusSticky3Img from "../../assets/img/virus-sticky-note-3.png";
import virusSticky4Img from "../../assets/img/virus-sticky-note-4.png";
import laptopImg from "../../assets/img/laptop.png";
import virusImg from "../../assets/img/virus_window.png";

// FUNCTION EXPORT
export default function Part11({ step, setShowScrolldown }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade in virus 2" },
    { stepNumber: "2", height: null, description: "fade in virus 3" },
    { stepNumber: "3", height: null, description: "fade in virus 4" },
    {
      stepNumber: "4",
      height: null,
      description: "fade in bottom text and laptop",
    },
    { stepNumber: "5", height: null, description: "fade out virus 3" },
    { stepNumber: "6", height: null, description: "fade out virus 2" },
    { stepNumber: "7", height: null, description: "fade out virus 1" },
    { stepNumber: "8", height: null, description: "fade in virus text" },
    {
      stepNumber: "9",
      height: null,
      description: "remove scroll down element",
    },
  ];

  // REFS
  const virusSticky1El = useRef(null);
  const virusSticky2El = useRef(null);
  const virusSticky3El = useRef(null);
  const virusSticky4El = useRef(null);
  const textEl = useRef(null);
  const laptopContainerEl = useRef(null);
  const virus1El = useRef(null);
  const virus2El = useRef(null);
  const virus3El = useRef(null);
  const laptopTextEl = useRef(null);

  const virusSticky1ElDesktop = useRef(null);
  const virusSticky2ElDesktop = useRef(null);
  const virusSticky3ElDesktop = useRef(null);
  const virusSticky4ElDesktop = useRef(null);
  const textElDesktop = useRef(null);
  const laptopContainerElDesktop = useRef(null);
  const virus1ElDesktop = useRef(null);
  const virus2ElDesktop = useRef(null);
  const virus3ElDesktop = useRef(null);
  const laptopTextElDesktop = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(virusSticky2El.current, direction);

            animate.fadeInOnEnter(virusSticky2ElDesktop.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnEnter(virusSticky3El.current, direction);

            animate.fadeInOnEnter(virusSticky3ElDesktop.current, direction);
            break;
          }
          case "3": {
            animate.fadeInOnEnter(virusSticky4El.current, direction);

            animate.fadeInOnEnter(virusSticky4ElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeInOnEnter(textEl.current, direction);
            animate.fadeInOnEnter(laptopContainerEl.current, direction);

            animate.fadeInOnEnter(textElDesktop.current, direction);
            animate.fadeInOnEnter(laptopContainerElDesktop.current, direction);
            break;
          }
          case "5": {
            animate.fadeOutOnEnter(virus3El.current, direction);

            animate.fadeOutOnEnter(virus3ElDesktop.current, direction);
            break;
          }
          case "6": {
            animate.fadeOutOnEnter(virus2El.current, direction);

            animate.fadeOutOnEnter(virus2ElDesktop.current, direction);
            break;
          }
          case "7": {
            animate.fadeOutOnEnter(virus1El.current, direction);

            animate.fadeOutOnEnter(virus1ElDesktop.current, direction);
            break;
          }
          case "8": {
            animate.fadeInOnEnter(laptopTextEl.current, direction);

            animate.fadeInOnEnter(laptopTextElDesktop.current, direction);
            break;
          }
          case "9": {
            setShowScrolldown(false);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(virusSticky2El.current, direction);

            animate.fadeOutOnExit(virusSticky2ElDesktop.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnExit(virusSticky3El.current, direction);

            animate.fadeOutOnExit(virusSticky3ElDesktop.current, direction);
            break;
          }
          case "3": {
            animate.fadeOutOnExit(virusSticky4El.current, direction);

            animate.fadeOutOnExit(virusSticky4ElDesktop.current, direction);
            break;
          }
          case "4": {
            animate.fadeOutOnExit(textEl.current, direction);
            animate.fadeOutOnExit(laptopContainerEl.current, direction);

            animate.fadeOutOnExit(textElDesktop.current, direction);
            animate.fadeOutOnExit(laptopContainerElDesktop.current, direction);
            break;
          }
          case "5": {
            animate.fadeInOnExit(virus3El.current, direction);

            animate.fadeInOnExit(virus3ElDesktop.current, direction);
            break;
          }
          case "6": {
            animate.fadeInOnExit(virus2El.current, direction);

            animate.fadeInOnExit(virus2ElDesktop.current, direction);
            break;
          }
          case "7": {
            animate.fadeInOnExit(virus1El.current, direction);

            animate.fadeInOnExit(virus1ElDesktop.current, direction);
            break;
          }
          case "8": {
            animate.fadeOutOnExit(laptopTextEl.current, direction);

            animate.fadeOutOnExit(laptopTextElDesktop.current, direction);
            break;
          }
          case "9": {
            setShowScrolldown(true);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part11">
          <div className="part11__container-mobile">
            {/* <div className="text text-top">
            You now know what a virus is and its key parts:
          </div> */}
            <div className="virus-container">
              <div className="virus virus-1" ref={virusSticky1El}>
                <img src={virusSticky1Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-2" ref={virusSticky2El}>
                <img src={virusSticky2Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-3" ref={virusSticky3El}>
                <img src={virusSticky3Img} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-4" ref={virusSticky4El}>
                <img src={virusSticky4Img} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="text" ref={textEl}>
              <div className="text-bottom">
                Use this information to{" "}
                <b>better understand how viruses spread</b> to make us sick.
              </div>
            </div>
            <div className="laptop-container" ref={laptopContainerEl}>
              <div className="laptop">
                <img src={laptopImg} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-1" ref={virus1El}>
                <img src={virusImg} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-2" ref={virus2El}>
                <img src={virusImg} alt="" className="img-fluid" />
              </div>
              <div className="virus virus-3" ref={virus3El}>
                <img src={virusImg} alt="" className="img-fluid" />
              </div>
              <div className="laptop-text" ref={laptopTextEl}>
                And what we can do to reduce it.
              </div>
            </div>
          </div>
          <div className="part11__container-desktop">
            {/* <div className="text text-top">
            You now know what a virus is and its key parts:
          </div> */}
            <div className="part11__container-desktop-left">
              <div className="virus-container">
                <div className="virus virus-1" ref={virusSticky1ElDesktop}>
                  <img src={virusSticky1Img} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-2" ref={virusSticky2ElDesktop}>
                  <img src={virusSticky2Img} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-3" ref={virusSticky3ElDesktop}>
                  <img src={virusSticky3Img} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-4" ref={virusSticky4ElDesktop}>
                  <img src={virusSticky4Img} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
            <div className="part11__container-desktop-right">
              <div className="text" ref={textElDesktop}>
                <div className="text-bottom">
                  Use this information to{" "}
                  <b>better understand how viruses spread</b> to make us sick.
                </div>
              </div>
              <div className="laptop-container" ref={laptopContainerElDesktop}>
                <div className="laptop">
                  <img src={laptopImg} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-1" ref={virus1ElDesktop}>
                  <img src={virusImg} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-2" ref={virus2ElDesktop}>
                  <img src={virusImg} alt="" className="img-fluid" />
                </div>
                <div className="virus virus-3" ref={virus3ElDesktop}>
                  <img src={virusImg} alt="" className="img-fluid" />
                </div>
                <div className="laptop-text" ref={laptopTextElDesktop}>
                  And what we can do to reduce it.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
